var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlfaBankCard = function SvgAlfaBankCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{enable-background:new;}\n\t.st1{fill:#EF3124;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,25.3c1.5-4.5,5.9-16.3,6.2-16.6c0.6-1,1.7-1.2,2.7-1.2c0.5,0,0.6,0,1.1,0C23,7.6,23.5,8,24,8.7 c0.5,1,0.7,1.7,1,2.7c1.5,4.5,2.9,9.3,4.7,13.8v0.1c-0.2,0-0.2,0-0.5,0c-1,0-2,0-3.2,0c-0.2,0-0.4,0-0.5-0.2c-0.2-1-0.7-2-1-3 c0-0.2-0.2-0.2-0.5-0.2c-2,0-4.2,0-6.2,0c-0.2,0-0.5,0-0.5,0.2c-0.2,1-0.7,2-1,3c0,0.2-0.2,0.2-0.5,0.2 C14.9,25.3,12.5,25.3,12.2,25.3z M23.4,18.6c-0.7-2.5-1.5-5-2.2-7.4l0,0c-0.7,2.5-1.7,5-2.5,7.4C20.1,18.6,21.9,18.6,23.4,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8,31.1c0,1.2,0,2.4,0,3.4c-5.9,0-11.6,0-17.6,0v-0.2c0-1,0-2,0-3c0-0.2,0-0.2,0.2-0.2 C18.1,31.1,29.8,31.1,29.8,31.1z"
  }))));
};
export default SvgAlfaBankCard;